<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret grupp
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent>
								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="agreementgroup">
											<label>
												Aftale
											</label>

											<select v-model="agreementID" ref="agreementid">
												<option v-for="(agreement, index) in agreements" :key="index" v-bind:value="agreement.id">
													{{ agreement.name }}
												</option>
											</select><span></span>
										</div>

										<div class="input-group" ref="namegroup">
											<label for="name">
												Navn
											</label>
											<input v-model="name" type="text" ref="name" value>
										</div>

										<div class="input-group" ref="typegroup">
											<label for="status">
												Gruppe type
											</label>
											<select v-model="type" ref="type">
												<option value="2">Klasse</option>
												<option value="4">Medarbejdere</option>
												<option value="3">Stue</option>
												<option value="1">Anden gruppe</option>
											</select><span></span>
										</div>
									</div>
								</div>
								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="deleteData" class="delete left" v-if="dialogMode == 'edit'">
										Slet
									</button>
									<button type="button" @click.prevent="close" class="text space">
										Tilbage
									</button>
									<button type="button" @click.prevent="saveData">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";

	export default {
		name: "PersonGroupEdit",
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret gruppe",
				customerID: "0",
				persongroupID: "0",
				agreements: [],

				name: "",
				type: "2",
				agreementID: 0,
				persongroup:
				{
					name: "",
					type: "2",
					agreementID: 0
				},
			}
		},
		mounted()
		{
			this.setModalIsVisible()
			this.customerID = this.$route.params.customerid
			this.getAgreements()

			if (this.$route.name == "PersonGroupEdit")
			{
				this.dialogMode = "edit"
				this.dialogTitle = "Rediger gruppe"
				this.persongroupID = this.$route.params.persongroupid
				this.loadData()
			}
			else
			{
				this.dialogMode = "create"
				this.dialogTitle = "Opret gruppe"
				this.$refs.name.focus()
			}
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		methods:
		{
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.name != this.persongroup.name)
				changes = changes || (this.type != this.persongroup.type)

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false;
			},
			close()
			{
				if (this.checkForChanges())
				{
					return;
				}

				if (this.dialogMode == "edit")
				{
					this.$router.push({ name: "PersonGroupShow", params: { persongroupid: this.persongroupid, customerid: this.customerID, agreementid: this.agreementID } })
				}
				else
				{
					this.$router.push({ name: "Agreements", params: { customerid: this.customerID, agreementid: this.agreementID } })
				}
			},
			async getAgreements()
			{
				// Get agreements
				let searchdata = { customerID: this.customerID, status: 0, period: 0 }
				var agreementsResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENTS, searchdata)

				if (agreementsResult.status == 200)
				{
					this.agreements = agreementsResult.data

					if (this.agreements && this.agreements.length > 0)
					{
						this.agreementID = this.agreements[0].id
					}

					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					logError("PersonGroupEdit.loadData() getAgreements", error)
					alert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.$router.push({ name: "PersonGroupEdit" })
				}
			},
			async loadData()
			{
				if (this.persongroupID)
				{
					this.setAppAsBusyModal();

					try
					{
						var result = await this.$store.dispatch(types.ACTION_GET_PERSONGROUP, this.persongroupID);

						if (result.status == 200)
						{
							this.persongroup = result.data;
							this.name = result.data.name
							this.type = result.data.type
							this.agreementID = result.data.agreementid
							this.setAppAsIdle()
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonGroupEdit.loadData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
							this.$router.push({ name: "PersonGroups" })
						}
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("PersonGroupEdit.loadData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "PersonGroups" })
					}
				}
				else
				{
					alert("Forkert adresse. Opdater venligst siden, og prøv igen. 3");
					this.$router.push({ name: "PersonGroups" })
				}
			},
			async saveData()
			{
				try
				{
					var valid = true
					var validationFocus = false

					if (this.agreementID == 0)
					{
						this.$refs.agreementgroup.setAttribute("data-validation", "Vælg venligst en aftale")
						this.$refs.agreementid.focus()
						validationFocus = true
						valid = false
					}
					else
					{
						this.$refs.agreementgroup.removeAttribute("data-validation")
					}

					if (this.name.length == 0)
					{
						this.$refs.namegroup.setAttribute("data-validation", "Indtast venligst et navn")
						valid = false

						if (!validationFocus)
						{
							validationFocus = true
							this.$refs.name.focus()
						}
					}
					else
					{
						this.$refs.namegroup.removeAttribute("data-validation")
					}

					if (!valid)
					{
						return;
					}

					this.setAppAsBusyModal()

					var data =
					{
						id: this.persongroupID,
						customerid: this.customerID,
						agreementid: this.agreementID,
						name: this.name,
						type: this.type
					}

					if (this.dialogMode == "edit")
					{
						var result = await this.$store.dispatch(types.ACTION_UPDATE_PERSONGROUP, data);

						if (result.status == 200)
						{
							this.persongroup = result.data
							this.setAppAsIdle()
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
							this.$router.push({ name: "PersonGroups", params: { updatedPersonGroup: this.persongroup } })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle();

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede en gruppe med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message);
								alert("Der opstod en fejl. Opdater siden og prøv igen.");
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonGroup.saveData()", result.status)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
					else
					{
						var result = await this.$store.dispatch(types.ACTION_ADD_PERSONGROUP, data);

						if (result.status == 201)
						{
							this.persongroup = result.data
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.ADDED)
								this.$router.push({ name: "PersonGroups", params: { addedPersonGroup: this.persongroup } })
						}
						else if (result.status == 400)
						{
							this.setAppAsIdle();

							if (result.data && result.data.ErrorCode && result.data.ErrorCode == "NameInUse")
							{
								this.$refs.namegroup.setAttribute("data-validation", "Der findes allerede en gruppe med navnet " + this.name + ". Indtast venligst et andet navn.")
								this.$refs.name.focus()
							}
							else
							{
								log("Update error: " + result.data.message);
								alert("Der opstod en fejl. Opdater siden og prøv igen.");
							}
						}
						else
						{
							this.setAppAsIdle()
							logError("PersonGroup.saveData()", error)
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
				}
				catch (ex)
				{
					this.showErrorAlert(ex)
					this.setAppAsIdle()
				}
			},
			async deleteData()
			{
				if (confirm("Er du sikker? Sletningen kan ikke fortrydes."))
				{
					try
					{
						await this.$store.dispatch(types.ACTION_DELETE_PERSONGROUP, this.persongroupID)
							.then(response =>
							{
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.$router.push({ name: "PersonGroups"})
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("PersonGroup.deleteData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
							});
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("PersonGroup.deleteData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
						this.$router.push({ name: "PersonGroups" })
					}
				}
			},
		}
	};
</script>